import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { handleSessionExpired } from './auth-store'

function isAuthError(error: unknown) {
  return error instanceof Error && error.message === 'Authentication required'
}

export const createQueryClient = () => {
  const client = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (isAuthError(error)) handleSessionExpired(client)
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (isAuthError(error)) handleSessionExpired(client)
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => (isAuthError(error) ? false : failureCount < 1),
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: (failureCount, error) => (isAuthError(error) ? false : failureCount < 1),
      },
    },
  })
  return client
}

export const queryClient = createQueryClient()
